/**
 * 言語切り替え用Configの言語の詳細
 */
export interface LanguageDetail {
  value: string;
  label: string;
}

/**
 * 言語切り替え用Config
 */
export interface LanguageSwitchConfig {
  [key: string]: LanguageDetail;
}

/**
 * 言語切り替え用Configの定義
 */
export const DEBUG_LANGUAGE_SWITCH_CONFIG: LanguageSwitchConfig = {
  debug_language_ja: {
    value: 'ja',
    label: '日本語',
  },
  debug_language_en: {
    value: 'en',
    label: '英語',
  },
  debug_language_cn: {
    value: 'cn',
    label: '中国語(簡体字)',
  },
  debug_language_hk: {
    value: 'hk',
    label: '中国語(繁体字/香港)',
  },
  debug_language_tw: {
    value: 'tw',
    label: '中国語(繁体字/台湾)',
  },
  debug_language_ko: {
    value: 'ko',
    label: '韓国語',
  },
  debug_language_th: {
    value: 'th',
    label: 'タイ語',
  },
  debug_language_vn: {
    value: 'vn',
    label: 'ベトナム語',
  },
  debug_language_id: {
    value: 'id',
    label: 'インドネシア語',
  },
  debug_language_fr: {
    value: 'fr',
    label: 'フランス語',
  },
  debug_language_de: {
    value: 'de',
    label: 'ドイツ語',
  },
  debug_language_es: {
    value: 'es',
    label: 'スペイン語',
  },
  debug_language_ru: {
    value: 'ru',
    label: 'ロシア語',
  },
  debug_language_it: {
    value: 'it',
    label: 'イタリア語',
  },
  debug_language_sv: {
    value: 'sv',
    label: 'スウェーデン語',
  },
  debug_language_tr: {
    value: 'tr',
    label: 'トルコ語',
  },
};
